import * as React from 'react';
import { Spin } from "antd/es";

const style: any = {
  top: 0,
  zIndex: '10',
  width: '100%',
  height: '50px',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

export default function MapDataLoader() {
  return (
    <div style={{ ...style }}>
      {/*
        Centred twice over: the banner centres this h1, and the h1 centres its own line so the `Spin`
        (taller than the text) cannot shift the label off the middle the way inline baseline alignment did
      */}
      <h1 style={{ margin: 0, lineHeight: 1, display: 'flex', alignItems: 'center', gap: '8px' }}>
        {/* The line box is centred but the glyph ink sits 2.5px lower (font asc 27 / desc 6 at 28px) */}
        <span style={{ transform: 'translateY(-2.5px)' }}>Loading data...</span>
        <Spin />
      </h1>
    </div>
  )
}